<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="custom / skolfederation">
      <g id="Vector">
        <path
          d="M15.8599 13.4395C15.8599 15.1822 14.7847 16.2318 13.093 16.2828H4.77707V22H2V11.1567C2 6.10701 6.06115 2 11.0548 2H15.8853V4.80764H11.0548C7.5949 4.80764 4.77707 7.65605 4.77707 11.1516V13.4395H15.8599Z"
          fill="#F37E2A"
        />
        <path
          d="M18.6624 7.76306V2H21.4394V12.6854C21.4394 17.8166 17.4445 21.9949 12.5375 21.9949H7.55409V19.1822H12.5375C15.9159 19.1822 18.6624 16.2675 18.6624 12.6854V10.6013H7.67638C7.67638 8.8586 8.75154 7.81401 10.4433 7.76306H18.6624Z"
          fill="#F37E2A"
        />
      </g>
    </g>
  </svg>
</template>
